// extracted by mini-css-extract-plugin
module.exports = {"background":"ErrorPage_background__xtJR7","container":"ErrorPage_container__7UOjh","image":"ErrorPage_image__3Rvhn","content":"ErrorPage_content__8x_kj"};